import React from "react";
import { SyncService } from "frontend/services/syncService";
import { RW } from "shared/datamodel/replicache-wrapper/mutators";
import { useAtomValue } from "jotai";
import { orgChartNodeDataForSidePanel } from "state-atoms";
import OrgchartSidePanelContent from "./orgchart-side-panel-content";

export default function OrgChartSidePanel({
  syncService,
  patchCanvasElement,
  onClose,
  onUpgradeRequired,
}: {
  syncService: SyncService<RW> | null;
  patchCanvasElement: (args: { id: string; patch: any; inversePatch?: any; details?: any }) => void;
  onClose: () => void;
  onUpgradeRequired?: () => void;
}) {
  const nodeData = useAtomValue(orgChartNodeDataForSidePanel);

  if (nodeData == null) {
    console.warn("side panel opened without node data");
    onClose();
    return null;
  }

  return (
    <OrgchartSidePanelContent
      nodeData={nodeData}
      syncService={syncService}
      patchCanvasElement={patchCanvasElement}
      onClose={onClose}
      onUpgradeRequired={onUpgradeRequired}
    />
  );
}
